<template>
  <footer class="app-footer">
    <div class="footer-inner">
      <div class="footer-brand">
        <span class="footer-logo">📚 LearnNow</span>
        <p class="footer-tagline">Learn something new, anywhere, anytime.</p>
      </div>
    </div>

    <div class="footer-bottom">
      <p>
        &copy; 2020 – {{ year }} LearnNow. All rights reserved.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
.app-footer {
  background: var(--color-surface);
  backdrop-filter: blur(8px);
  border-top: 1px solid var(--color-border);
  margin-top: auto;
  overflow: hidden;
  box-shadow: none;
}

.footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.6rem 1rem;
  flex-wrap: wrap;
}

.footer-brand {
  flex: 1;
  min-width: 200px;
}

.footer-logo {
  font-family: var(--font-brand);
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--color-primary-dark);
}

.footer-tagline {
  margin: 0.15rem 0 0;
  font-size: 0.8rem;
  color: var(--color-text-muted);
}

.social-links {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.social-links a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background: var(--color-primary-light);
  color: var(--color-primary-dark);
  font-size: 1.25rem;
  transition: background 0.2s ease, transform 0.15s ease, color 0.2s ease;
}

.social-links a:hover {
  transform: translateY(-2px);
}

.social-links a[aria-label="Facebook"]:hover {
  background: #1877f2;
  color: #fff;
}

.social-links a[aria-label="Twitter"]:hover {
  background: #1da1f2;
  color: #fff;
}

.social-links a[aria-label="Instagram"]:hover {
  background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);
  color: #fff;
}

.footer-bottom {
  border-top: 1px solid var(--color-border);
  padding: 0.45rem 1rem;
  text-align: center;
}

.footer-bottom p {
  margin: 0;
  font-size: 0.78rem;
  color: var(--color-text-muted);
}

@media (max-width: 576px) {
  .footer-inner {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0.6rem 0.75rem;
  }

  .footer-bottom {
    padding: 0.4rem 0.75rem;
  }
}
</style>
